import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService,
  Box3InkomenUitSparenEnBeleggen, IncomeTaxEntity,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../gedeelde-componenten/gedeelde-componenten.component";
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';


@Component({
  selector:
    'snelstart-venture-fiscaal-feature-box3-niet-vrijgestelde-kapitaalverzekeringen',
  templateUrl: './box3-niet-vrijgestelde-kapitaalverzekeringen.component.html',
  styleUrls: ['./box3-niet-vrijgestelde-kapitaalverzekeringen.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    CommonModule
  ]
})
export class Box3NietVrijgesteldeKapitaalverzekeringenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;

    @Input() public id!: string;
    public clientId!: string;

    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public nietVrijgesteldeKapitaalverzekeringen = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router,private fb: FormBuilder) {
        this.nietVrijgesteldeKapitaalverzekeringen = this.fb.group({
            box3NietVrijgesteldeKapitaalverzekeringen:
                this.fb.array<Box3InkomenUitSparenEnBeleggen>([])
        })
    }

    get box3NietVrijgesteldeKapitaalverzekeringen(): FormArray {
        return this.nietVrijgesteldeKapitaalverzekeringen.get('box3NietVrijgesteldeKapitaalverzekeringen') as FormArray;
    }

    addRijNietVrijgesteldeKapitaalverzekeringen(): void {
        this.box3NietVrijgesteldeKapitaalverzekeringen.push(this.createNietVrijgesteldeKapitaalverzekeringenFormGroup()
        )
    }

    verwijderRijNietVrijgesteldeKapitaalverzekeringen(index: number): void {
        this.box3NietVrijgesteldeKapitaalverzekeringen.removeAt(index);
        this.nietVrijgesteldeKapitaalverzekeringen.updateValueAndValidity()
        this.nietVrijgesteldeKapitaalverzekeringen.markAsDirty()
        this.saveForm()
    }

    createNietVrijgesteldeKapitaalverzekeringenFormGroup(kapverz?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: kapverz ? kapverz.omschrijving : undefined,
            bedrag: kapverz ? kapverz.bedrag : undefined,
        } as OmschrijvingEnBedrag))
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.nietVrijgesteldeKapitaalverzekeringen.dirty
  }


  private updateForm(): void {
        const nietVrijgesteldeKapitaalverzekeringenLijst = this.incomeTaxEntity.aangifte?.box3?.nietVrijgesteldeKapitaalverzekeringen || [];
        const formArray = this.nietVrijgesteldeKapitaalverzekeringen.get('box3NietVrijgesteldeKapitaalverzekeringen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > nietVrijgesteldeKapitaalverzekeringenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < nietVrijgesteldeKapitaalverzekeringenLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(nietVrijgesteldeKapitaalverzekeringenLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createNietVrijgesteldeKapitaalverzekeringenFormGroup(nietVrijgesteldeKapitaalverzekeringenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity.aangifte,
            box3: {
                ...this.incomeTaxEntity?.aangifte?.box3,
                nietVrijgesteldeKapitaalverzekeringen: this.nietVrijgesteldeKapitaalverzekeringen.value.box3NietVrijgesteldeKapitaalverzekeringen
            }
        } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        }, 0)
    }
}
